module.exports = __webpack_public_path__ + "static/media/player.4d6a77e7.svg";